module.exports = __webpack_public_path__ + "img/img_digitalisierung_02.a3b798f6.jpg";